import React from 'react'
import styled from 'styled-components'
// import {keyframes} from 'styled-components'
import { Link } from 'react-router-dom'
import stefonAI from '../images/steflogo2.webp'
// import stefonAI from '../images/stefon25.jpg'
// import stefonAI from '../images/steflogo3.webp'

const AboutContainer = styled.main`
  display: flex;
  // justify-content: center;
  align-items: center;
  flex-direction: column;
  height: 100vh;
  font-family: 'Ubuntu Condensed', sans-serif;
`
const AboutSection = styled.section`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 600px;
  padding: 0 15px 0 15px;

  @media(max-width: 620px){
    width: 500px
  }

  @media(max-width: 515px){
    width: 300px
  }
`
// const AboutSectionBG = styled.div`
//   width: 400px;
//   height: 400px;
//   border-radius: 180%;
//   position: absolute;
//   top: 30%;
//   left: 18%;
//   z-index: -1;
//   filter: grayscale(80%);
//   background-image: url(${stefonAI});
//   background-size: 400px 400px;
//   background-repeat: no-repeat;
//   background-position: 50% 50%;

// `

export const Header = styled.h1`
  margin: 15px 0px;
  text-align: center;
  font-size: 24px;
  letter-spacing: 3px;
  line-height: 1.6;
  font-family: 'Ubuntu Condensed', sans-serif;
  // color: rgb(82,150,250);
  color:  #e8eddf;
  @media(max-width: 620px){
    font-size: 28px;
  }
`
export const Statement = styled.p`
  font-size: 18px;
  text-align: left;
  letter-spacing: 3.5px;
  line-height: 1.5;
  margin-bottom: 20px;
  color: #e8eddf;
  z-index: 1;

  @media(max-width: 620px){
    font-size: 18px
  }

  @media(max-width: 515px){
    font-size: 18px
  }
`
const Linked = styled(Link)`
  background: #e8eddf;
  color: rgb(0,150,250);
  text-decoration: none;
  font-weight: 900;
  border-radius: 5px;
  padding: 3px;
  border: solid grey .5px;
  white-space: nowrap;
`
const ArtLink = styled(Link)`
  background: #e8eddf;
  color: rgb(200,100,0);
  text-decoration: none;
  font-weight: 900;
  border-radius: 5px;
  padding: 3px;
  border: solid grey .5px
`
// const TechSection = styled.section`
//   margin: 1em 0 8em 0;
//   border-radius: 10px;
//   padding: 5px;
//   background: #e8eddf;
// `
// const ToolBelt = styled.div`
//   display: grid;
//   grid-template-columns: repeat(5, 1fr);
//   grid-gap: 35px;

//   @media(max-width: 620px){
//     grid-template-columns: repeat(4, 1fr);
//   }

//   @media(max-width: 515px){
//     grid-template-columns: repeat(3, 1fr);
//     text-align: center;
//     grid-gap: 15px;
//   }
// `
// const Icon = styled.i`
//   font-size: 3.25em;
//   padding: 10px;

//   &:hover{
//     border-radius: 10px;
//     background-image: radial-gradient(rgb(100,150,250), rgba(100,150,250,.7), rgba(100,150,250,.2225));
//     box-shadow: 0px 0px 50px rgb(100,150,250);
//   }
// `
// const Divider = styled.hr`
//   margin: 15px;
//   width: 8%
// ` 

// const interference = keyframes `
//     0% {
//         transform: skewX(0)
//     }

//     31% {
//         transform: skewX(0)
//     }

//     31.5% {
//         transform: skewX(89deg)
//     }

//     32% {
//         transform: skewX(89deg)
//     }

//     32.1% {
//         transform: skewX(0)
//     }

//     33% {
//         transform: skewX(0)
//     }

//     50% {
//         transform: skewX(0deg)
//     }

//     94% {
  
//         transform: skewX(0)
//     }

//     95.1% {
//         transform: skewX(20deg)
//     }

//     95.2% {
//         transform: skewX(89deg)
//     }

//     95.3% {
//         transform: skewX(-10deg)
//     }

//     100% {
//         transform: skewX(0)
//     }
// `

const Logo = styled.img`
  position: absolute;
  top: 10%;
  border-radius: 180%;
  margin-top: 8px;
  filter: grayscale(70%);
  object-fit: cover;
  opacity: .1;
  `
  // animation: ${interference} 1s 4;


export default function AboutMe() {

  const [years, setYears] = React.useState()

  React.useEffect(() => {

    setYears(getYear())
    // changeLogo()
  }, [])


  // function changeLogo(){
  //   // change the logo after 5 seconds to a different image.
    
  //   setTimeout(() => {
  //     const logo = document.querySelector('#logo')
  //     logo.src = stefonLogo
  //   }, 3500)

  // }

  function getYear(){
    // gets the number of years from my start date at datadog.
    const startDate = new Date('9/13/2021')
    const today = new Date()
    const timeDiff = Math.abs(today - startDate)
    const dayDiff = Math.ceil(timeDiff / (1000 * 60 * 60 * 24))

    const numOfYears = dayDiff / 365
    const whole = Math.floor(numOfYears)
    const mod = numOfYears % whole
    return whole + (mod >= .5 && .5 )
  }

  return (
    <>
      <AboutContainer>
        <AboutSection>
          
          <Logo id="logo" src={stefonAI} alt="image representing Stefon"  width="350" height="350"/>
          <Statement>
            A lifelong creative with a background in <Linked to='/webapps'>web development</Linked>, education, music, and visual art. My creative expression sits at the intersection of systems thinking and technical execution.<br></br><br></br>For the past {years} years, I’ve worked on the Websites Team at Datadog, growing from building and testing individual websites to owning content pipelines, strengthening production resilience, and driving technical communication across infrastructure migrations.<br></br><br></br>Outside of tech, I’m a <ArtLink to='/myart'>singer, songwriter and painter</ArtLink>. My creative practices and engineering ability work hand-in-hand. Whether communicating technical decisions or composing a song. I’m driven by curiosity and a desire to understand how things work.<br></br><br></br>I enjoy solving complex problems and building scalable, reliable solutions that balance technical rigor with practicality.<br></br><br></br>Collaborators describe me as analytical, detail-oriented, proactive, and adaptable. I strive to create work that is thoughtful, functional, and built to last.
          </Statement>
        </AboutSection>
        {/* <Divider /> */}
        {/* <TechSection>
          <Header style={{color: 'rgb(82,150,250)'}}>Technical Utility Belt</Header>
          <ToolBelt>
            <Icon className="devicon-javascript-plain"></Icon>
            <Icon className="devicon-python-plain-wordmark"></Icon>
            <Icon className="devicon-ruby-plain"></Icon>
            <Icon className="devicon-html5-plain-wordmark"></Icon>
            <Icon className="devicon-css3-plain-wordmark"></Icon>
            <Icon className="devicon-react-plain-wordmark"></Icon>
            <Icon className="devicon-nodejs-plain-wordmark"></Icon>
            <Icon className="devicon-express-original-wordmark"></Icon>
            <Icon className="devicon-postgresql-plain-wordmark"></Icon>
            <Icon className="devicon-visualstudio-plain-wordmark"></Icon>
          </ToolBelt>
        </TechSection> */}

      </AboutContainer>
    </>
  )
}
